import { makeStyles } from '@material-ui/core/styles';

export const useBoardsStyles = makeStyles({
  titleTab: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '16px',
    borderBottom: '1px solid black',
  },
  titleFont: {
    fontWeight: 'bold',
    fontSize: '16px',
  },
  totalBoards: {
    color: '#e6005a',
    fontSize: '16px',
    marginLeft: '20px',
    marginRight: '10px',
  },
  totalBoardsGreen: {
    fontSize: '16px',
    marginRight: '10px',
    marginLeft: '20px',
  },
  borderBox: {
    borderRadius: '10px',
    border: '1px solid lightgray',
    overflow: 'hidden',
    margin: '0px 10px',
  },
  mobilePOWrapper: {
    marginBottom: 8,
  },
  tabsBoards: {
    backgroundColor: 'white',
  },
  indicatorBoards: {
    backgroundColor: '#21a1f9',
  },
  none: {
    display: 'none',
  },
  floorGroup: {
    borderTop: '1.3px solid black',
    margin: '10px 0px',
  },
  floorRow: {
    margin: '10px 0px',
  },
  inputGrid: {
    margin: '8px 0px',
    width: '90%',
    textAlign: 'center',
  },
  pointer: {
    cursor: 'pointer',
    marginLeft: '10px',
  },
  contedWrong: {
    backgroundColor: '#ff000085',
  },
  geoLocationError: {
    color: '#e6005a',
    fontSize: '16px',
    marginRight: '10px',
    marginBottom: '10px',
  },
  button: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  signButton: {
    backgroundColor: '#21a1f9',
    color: '#fff',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#1976d2',
    },
  },
  orderDescription: {
    fontSize: '12px',
  },
  orderDescriptionSeparator: {
    borderTop: '1px solid lightgray',
  },
  whiteBoxMobile: {
    marginBottom: '20px',
    backgroundColor: 'white',
    borderRadius: '10px',
    border: '1px solid lightgray',
    width: '100%',
  },
  totalBoardsMobile: {
    color: '#e6005a',
    fontSize: '12px',
  },
  totalBoardsGreenMobile: {
    fontSize: '12px',
  },
  floorGroupMobile: {
    borderTop: '1.3px solid lightgray',
    padding: '10px',
  },
  floorHeader: {
    display: 'flex',
    backgroundColor: 'rgba(211,211,211,0.3)',
    padding: '10px',
    justifyContent: 'space-between',
    overflow: 'hidden',
  },
  circleSmall: {
    width: '20px',
    height: '20px',
    minWidth: '20px',
    borderRadius: '10px',
    backgroundColor: '#21a1f9',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  iconCircle: {
    color: 'white',
    width: '20px',
  },
});